import { useEffect, useState } from "react";
import { BadgeDollarSign, Save } from "lucide-react";

import { api, apiError } from "@/lib/api";
import { useCurrency } from "@/context/CurrencyContext";

export default function CurrencySettingsPanel() {
  const { settings, setSettings } = useCurrency();
  const [rate, setRate] = useState(String(settings.usd_to_bob));
  const [mode, setMode] = useState(settings.display_mode);
  const [message, setMessage] = useState("");

  useEffect(() => {
    setRate(String(settings.usd_to_bob));
    setMode(settings.display_mode);
  }, [settings]);

  const save = async (event) => {
    event.preventDefault();
    setMessage("");
    try {
      const response = await api.put("/settings/currency", {
        usd_to_bob: Number(rate),
        display_mode: mode,
      });
      setRate(String(response.data.usd_to_bob));
      setSettings(response.data);
      setMessage("Moneda y tipo de cambio actualizados en todo el sistema.");
    } catch (error) {
      setMessage(apiError(error));
    }
  };

  return (
    <section className="currency-settings-panel" data-testid="currency-settings-panel">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">MONEDA</span>
          <h2>Dólar y boliviano</h2>
        </div>
        <BadgeDollarSign size={21} />
      </div>
      <p>
        Elige cómo se muestran los montos en todo el sistema. La base de cálculo se mantiene en USD.
      </p>
      <form className="currency-rate-form" data-testid="currency-rate-form" onSubmit={save}>
        <label htmlFor="usd-to-bob-rate">
          1 USD equivale a
          <span>
            <input
              data-testid="usd-to-bob-rate-input"
              id="usd-to-bob-rate"
              min="0.01"
              onChange={(event) => setRate(event.target.value)}
              step="0.01"
              type="number"
              value={rate}
            />
            <strong>BOB</strong>
          </span>
        </label>
        <fieldset className="currency-mode-fieldset">
          <legend>Mostrar importes como</legend>
          <div className="currency-mode-toggle">
            {["USD", "BOB", "BOTH"].map((value) => <button className={mode === value ? "active" : ""} data-testid={`currency-mode-${value.toLowerCase()}`} key={value} onClick={() => setMode(value)} type="button">{value === "BOTH" ? "Ambas" : value}</button>)}
          </div>
        </fieldset>
        <button className="primary-button" data-testid="currency-rate-save-button" type="submit">
          <Save size={16} /> Guardar tipo de cambio
        </button>
      </form>
      {message && <p className="form-note" data-testid="currency-settings-message">{message}</p>}
    </section>
  );
}
